export default {
  BLACK: "#000000",
  PRIMARY: "#ff5630",
  PRIMARY_LIGHTER: "#ffe1d7",
  PRIMARY_LIGHT: "#ff9e7a",
  DARKGRAY: "#2e2e2e",
  DARKLIGHTGRAY: "#8e8e8e",
  LIGHTGRAY: "#E8E8E8",
  LIGHTEST: "#F5F5F5",
  LIGHTGREEN: "#0BDA51",
  DARKGREEN: "#286f40",
  LIGHTESTGREEN: "#8FF5B8",
  MIDGRAY: "#C0C0C0",
};
